import EA from 'helpers/init';
import SmoothScroll from 'smoothscroll-for-websites';

export default EA.Methods.smoothScroll = () => {
    SmoothScroll();
};
